<template>
  <el-card shadow="never">
    <template #header>
      <div class="header">
        <el-breadcrumb class="breadcrumb" separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/website/setting' }">网站管理</el-breadcrumb-item>
          <el-breadcrumb-item>网站配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </template>
    <div style="width:80%">
      <el-form :model="form" label-width="180px">
        <el-form-item label="AppID(小程序ID)">
          <el-input v-model="form.appid" maxlength="50" show-word-limit/>
        </el-form-item>
        <el-form-item label="AppSecret(小程序密钥)">
          <el-input v-model="form.appsecret" placeholder="无需更改，请勿填写" maxlength="80" show-word-limit/>
        </el-form-item>
        <!-- <el-form-item label="appkey(万里牛)">
          <el-input v-model="form.wln_appkey" maxlength="150" show-word-limit/>
        </el-form-item>
        <el-form-item label="secret(万里牛)">
          <el-input v-model="form.wln_secret" maxlength="150" show-word-limit/>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>
<script lang="ts" setup>
import { reactive, onMounted } from 'vue'
import api from '@/api/index'
import { ElMessage, ElLoading } from 'element-plus'
const form = reactive({
  title: '',
  wln_appkey: '',
  wln_secret: '',
  appid: '',
  appsecret: '',
})
const getInit = () => {
  const loading = ElLoading.service({lock: true})
  api.accessoryApi.getInit().then((res:any)=>{
    if(res.code==200){
      form.title = res.data.title
      form.wln_appkey = res.data.wln_appkey
      form.wln_secret = res.data.wln_secret
      form.appid = res.data.appid
      form.appsecret = res.data.appsecret
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
}
const onSubmit = () => {
  const loading = ElLoading.service({lock: true})
  api.accessoryApi.setInit(form).then((res:any)=>{
    if(res.code==200){
      ElMessage({
        message: res.message,
        type: 'success',
      })
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
}
onMounted(() => {
  getInit()
})
</script>